"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedSessionState = void 0;
const s3s_client_1 = __importDefault(require("@zillow/s3s-client"));
const SESSION_ITEMS = ['currentGeography', 'geoIpLocation'];
/**
 * Get the latest and most specific regionId from the currentGeography object
 * @param {Object} currentGeography
 * @param {Object} currentGeography.best geo hierarchy
 * @param {Object} currentGeography.latest geo hierarchy
 * @returns {Number} regionId
 *
 */
const getRegionId = ({ best, latest }) => {
    const { cityId, countyId, stateId, nationId, neighborhoodId } = latest || best;
    return neighborhoodId || cityId || countyId || stateId || nationId;
};
/**
 * Get shared session state from endpoint and return the pieces we care about
 * @param {String} guid
 * @param {Object} endpoint Config
 * @param {Object} s3Options additional params to pass to the client
 *
 * @returns {Object} with regionId and centroid
 */
async function getSharedSessionState(guid, s3sHost, s3sOptions) {
    const { geoIpLocation, currentGeography } = await (0, s3s_client_1.default)(guid, s3sHost, s3sOptions)
        .getSharedSessionState(SESSION_ITEMS)
        // eslint-disable-next-line arrow-body-style, no-unused-vars
        .catch(e => {
        // let's log but return an object so we don't fail the page.
        // console.error(e);
        return {};
    });
    const sessionData = {};
    if (typeof geoIpLocation === 'object' && geoIpLocation.latLong) {
        sessionData.centroid = {
            lat: geoIpLocation.latLong.latitude,
            lon: geoIpLocation.latLong.longitude,
        };
    }
    if (typeof currentGeography === 'object') {
        sessionData.regionId = getRegionId(currentGeography);
    }
    return sessionData;
}
exports.getSharedSessionState = getSharedSessionState;
